import { Template } from "@models/template";
import { CommSend } from "@models/comm-send";
import { CommReceipt } from "@models/comm-receipt";

export class CommsStore {
  constructor(
    public templates: Template[] = [],
    public commSends: CommSend[] = [],
    public commReceipts: CommReceipt[] = [],
    public emailPreview: string = null,
    public numberOfRecipients: number = null,
  ) {}

  static clone(store: CommsStore) {
    const result = new this()

    result.templates          = [...store.templates]
    result.commSends          = [...store.commSends]
    result.commReceipts       = [...store.commReceipts]
    result.emailPreview       = store.emailPreview
    result.numberOfRecipients = store.numberOfRecipients

    return result
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/store/comms.ts